import MenuItem from '@/models/general/menuItem'

export default class CandidateMenuItem extends MenuItem {
  constructor(props) {
    super(props)

    this.candidateId = props.candidateId ?? null
    this.fullName = props.fullName ?? null
  }
}
